import type { User } from '@supabase/supabase-js';

/** Map Supabase Auth user to the legacy HyperSession shape used across the UI. */
export function hyperSessionFromSupabaseUser(user: User): HyperSession {
  const meta = user.user_metadata as Record<string, unknown> | undefined;
  const name =
    (typeof meta?.full_name === 'string' && meta.full_name.trim()) ||
    (typeof meta?.name === 'string' && meta.name.trim()) ||
    user.email?.split('@')[0] ||
    'Member';
  const now = new Date().toISOString();
  return {
    hy_sub_id: user.id,
    hy_sku: 'store',
    hy_sub_expire_date: now,
    hy_sub_created_at: now,
    hy_plan_dev_created_at: now,
    hy_plan_dev_name: 'Member',
    hy_user_id: user.id,
    hy_plan_dev_update_at: now,
    hy_plan_one_time: false,
    hy_name: name,
    hy_country: '',
    hy_country_code: '',
    hy_view: 0,
    hy_user_count: 1,
    synced_at: now,
    original_session_id: '',
  };
}

export interface HyperSession {
  hy_sub_id: string;
  hy_sku: string;
  hy_sub_expire_date: string;
  hy_sub_created_at: string;
  hy_plan_dev_created_at: string;
  hy_plan_dev_name: string;
  hy_user_id: string;
  hy_plan_dev_update_at: string;
  hy_plan_one_time: boolean;
  hy_name: string;
  hy_country: string;
  hy_country_code: string;
  hy_view: number;
  hy_user_count: number;
  synced_at: string;
  original_session_id?: string;
}

export interface HyperConnectRequest {
  session_id: string;
  app_id: string;
  fingerprint: string;
}

export interface HyperConnectResponse {
  result?: HyperSession;
  error?: string;
  message?: string;
}

export type ModalType = 
  | 'profile' | 'settings' | 'history' | 'analytics'
  | 'disclaimer' | 'terms' | 'privacy' | 'ethics' | 'upgrade'
  | 'insufficientCredits'
  | 'apiKeys' | 'userAssets' | 'appAssets' | 'assetsGallery'
  | 'error'
  | null;

export interface AppState {
  session: HyperSession | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  activeModal: ModalType;
  error: string | null;
}